import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [acknowledgment, setAcknowledgment] = useState(""); // New state for acknowledgment popup

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => emailjs.init("-4AA6g19veQlm-nA6"), []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("Sending...");

    // Send the email using EmailJS
    emailjs.send("service_iz56blg", "template_7jbuyz1", formData).then(
      (response) => {
        setStatus("");
        setAcknowledgment("Message sent successfully!"); // Show success acknowledgment
        setFormData({
          name: "",
          email: "",
          message: "",
        });
      },
      (error) => {
        setStatus("");
        setAcknowledgment(
          "Error: Message could not be sent. Please try again."
        ); // Show error acknowledgment
      }
    );
  };

  return (
    <>
      {/* Floating Icon */}
      <div
        className="fixed right-4 bottom-6 bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center cursor-pointer shadow-lg hover:scale-110 transform transition border border-white"
        onClick={() => setIsPopupOpen(true)}
        title="Contact Us"
      >
        <i className="fas fa-envelope text-xl"></i>
      </div>

      {/* Contact Popup */}
      {isPopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-lg p-8 rounded-2xl shadow-2xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-accent1 text-2xl font-extrabold">
                Contact Us
              </h2>
              <button
                className="text-gray-500 hover:text-gray-800"
                onClick={() => setIsPopupOpen(false)}
              >
                <i className="fas fa-times text-xl"></i>
              </button>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="text"
                name="name"
                value={formData.name}
                placeholder="Name"
                onChange={handleChange}
                className="w-full px-4 py-2 rounded-xl bg-gray-100 text-gray-800 border-2 border-transparent focus:outline-none focus:ring-2 focus:ring-primary"
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                placeholder="Email"
                onChange={handleChange}
                className="w-full px-4 py-2 rounded-xl bg-gray-100 text-gray-800 border-2 border-transparent focus:outline-none focus:ring-2 focus:ring-primary"
              />
              <textarea
                name="message"
                value={formData.message}
                placeholder="Message"
                onChange={handleChange}
                className="w-full px-4 py-2 rounded-xl bg-gray-100 text-gray-800 border-2 border-transparent focus:outline-none focus:ring-2 focus:ring-primary h-32"
              ></textarea>
              <button
                type="submit"
                className="w-full px-4 py-2 bg-primary text-white rounded-xl focus:ring-4 focus:ring-accent1 transition-all"
              >
                Send Message
              </button>
              {status && <p className="text-center mt-4">{status}</p>}
            </form>
          </div>
        </div>
      )}

      {/* Acknowledgment Popup */}
      {acknowledgment && (
        <div className="fixed bottom-6 right-6 bg-white text-gray-800 px-6 py-4 shadow-xl rounded-lg flex items-center space-x-4 z-50">
          <i
            className={`${
              acknowledgment.includes("successfully")
                ? "fas fa-check-circle text-green-500"
                : "fas fa-times-circle text-red-500"
            } text-2xl`}
          ></i>
          <span>{acknowledgment}</span>
          <button
            className="text-gray-500 hover:text-gray-800 ml-2"
            onClick={() => setAcknowledgment("")}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
      )}
    </>
  );
};

export default Contact;
